export default function StickyMobileCTA({ onClick }) {
    return (
        <button
            onClick={onClick}
            data-testid="sticky-mobile-cta"
            className="fixed bottom-5 left-5 right-5 z-40 md:hidden inline-flex items-center justify-center gap-2 bg-[#0D9488] hover:bg-[#0F766E] text-white font-bold rounded-full py-4 text-base shadow-[0_12px_36px_-6px_rgba(13,148,136,0.55)]"
        >
            Important Info <span>→</span>
        </button>
    );
}
